<template>
  <div class="personal">
    <Nav @mobile="mobile" ref="nevRef" />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
         <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div class="itemstabs" @click="handleclick(1)" :class="changeTabsIndex == 1?'activestabs':''">
              收益明细
            </div>
            <div class="itemstabs" @click="handleclick(2)"  :class="changeTabsIndex == 2?'activestabs':''">
              消费明细
            </div>
            <div class="itemstabs" @click="handleclick(3)"  :class="changeTabsIndex == 3?'activestabs':''">
              充值明细
            </div>
          </div>
          <el-divider></el-divider>
          <div style="display: flex;justify-content: space-between;">
            <div class="alertMsg">
              *提现请在APP上进行提现
            </div>
            <el-date-picker
            v-if="changeTabsIndex !=1"
             @change='changedeta'
              v-model="selectDataTime"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择日期">
            </el-date-picker>
          </div>
          <!-- 退单盒子 -->
          <div class="user_push_order" v-if="changeTabsIndex == 1">
              <div v-if="buyloglist.length>0" class="header_formtable">
                    <div class="headers">
                          <span>时间</span>
                          <span>礼物名称</span>
                          <span>礼物数量</span>
                          <span>礼物价值（元）</span>
                    </div>
                    <div class="groupOrder scroll_orders"  v-infinite-scroll="loadorderlist">
                      <div style="background-color:#F7F8FA;font-size: 14px;border-bottom: 1px solid #fff;" class="content_form" v-for="(item,index) in buyloglist " :key="index">
                          <span>
                             {{fifTime(item.createTime)}}
                          </span>
                          <span>
                            {{item.giftName}}
                          </span>
                          <span>
                            {{item.giftNum}}
                          </span>
                          <span>
                            {{item.giftPrice}}
                          </span>
                      </div>
                      <div class="loadorder" >
                        {{hitoryorderloading}}
                      </div>
                    </div>

              </div>
              <div class="groupOrder" v-else>
                <div class="emittxt">
                  <img class="emit" src="/static/person/order_emit.png" alt="" srcset="">
                  <span class="txt">暂时数据</span>
                </div>
              </div>
          </div>
        <div class="user_push_order" v-if="changeTabsIndex == 2">
            <div v-if="buyloglist.length>0" class="header_formtable">
                  <div class="headers">
                        <span>时间</span>
                        <span>消费类型</span>
                        <span>消费金额（龙币）</span>
                  </div>
                  <div class="groupOrder scroll_orders"  v-infinite-scroll="loadorderlist">
                    <div style="background-color:#F7F8FA;font-size: 14px;border-bottom: 1px solid #fff;" class="content_form" v-for="(item,index) in buyloglist " :key="index">
                        <span>
                           {{fifTime(item.createTime)}}
                        </span>
                        <span>
                          {{item.desc}}
                        </span>
                        <span>
                          {{item.amount}}
                        </span>
                    </div>
                    <div class="loadorder" >
                      {{hitoryorderloading}}
                    </div>
                  </div>

            </div>
            <div class="groupOrder" v-else>
              <div class="emittxt">
                <img class="emit" src="/static/person/order_emit.png" alt="" srcset="">
                <span class="txt">暂时数据</span>
              </div>
            </div>
        </div>
        <div class="user_push_order" v-if="changeTabsIndex == 3">
            <div v-if="buyloglist.length>0" class="header_formtable">
                  <div class="headers">
                        <span>时间</span>
                        <span>充值人</span>
                        <span>充值金额（元）</span>
                  </div>
                  <div class="groupOrder scroll_orders"  v-infinite-scroll="loadorderlist">
                    <div style="background-color:#F7F8FA;font-size: 14px;border-bottom: 1px solid #fff;" class="content_form" v-for="(item,index) in buyloglist " :key="index">
                        <span>
                           {{fifTime(item.createTime)}}
                        </span>
                        <span>
                          {{item.desc}}
                        </span>
                        <span>
                          {{item.amount}}
                        </span>
                    </div>
                    <div class="loadorder" >
                      {{hitoryorderloading}}
                    </div>
                  </div>

            </div>
            <div class="groupOrder" v-else>
              <div class="emittxt">
                <img class="emit" src="/static/person/order_emit.png" alt="" srcset="">
                <span class="txt">暂时数据</span>
              </div>
            </div>
        </div>
        </div>
      </div>
    </div>
    <!-- <Pay v-show="pay" :pay ="pay" :qrcode_url="qrcode_url" @pay='pays'></Pay> -->
    <!-- <Pay v-show="pay" :qrcode_url="qrcode_url" :pay ="pay" @pay='pays' :moneyData="hongbaodata"></Pay> -->
  </div>
</template>

<script>
import qs from "qs";
import Pay from "./Pay.vue";
import Nav from "./Nav.vue";
import slide from './template_slide.vue'
  import moment from 'moment';

  import {
    walletdetail,incomedetail
  } from "@/api/lz.js";
export default {
  name: "App",
  data() {
    return {
      checkOrderType:'',
      selectDataTime:'',
      hitoryorderloading:'玩命加载中···',
      buyloglist:[],
      hitoryorderindex:0,
      changeTabsIndex:1,
      b: 0,
      pay: false,
      token: "",
      personData: {},
      shenfenData: [],
      hongbaodata: [], //红包数据
      Mobile: "", //手机号
      qrcode_url: "",
      ExpPercentage: null, //经验条百分比
    };
  },
  filters: {
    fifphone(val) {
      if(!val){
        return ''
      }else{
        val  = String(val)
        let phone = val.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
        return phone;
      }
    }
  },
  created() {
    //页面加载时就从本地通过localstorage获取存储的token值
    this.token = localStorage.getItem("token");
    console.log(this.token);
  },
  methods: {
    changeSlide(data){
      this.$router.push(data);
    },
    handleclick(e){
      this.changeTabsIndex = e;
      this.buyloglist = []
      this.hitoryorderindex = 0
      this.getLishiTuidan()
    },
    changedeta(e){
      console.log(e);
      this.getLishiTuidan();
    },
    openDetails(item){
      this.fanganContent = item;
      this.alert_order_details = true
    },
    loadorderlist(){
      this.getLishiTuidan()
    },
    fifTime(time){
      	// console.log('时间转换',time);
      	return moment.unix(time).format('YYYY-MM-DD HH:mm:ss')
    },
    // 收益明细界面
    getLishiTuidan() {
      if (localStorage.getItem("token")) {
        this.hitoryorderloading = '加载中···'
        let i = this.hitoryorderindex;
        let detail =''
        console.log(this.selectDataTime);
        if(this.changeTabsIndex == 1){
          incomedetail({
            pageIndex:i+1
          }).then(res=>{
            if(res.data.code == 200){
              if(i==0){
                  if(res.data.data && res.data.data.list.length>0){

                    console.log('第一页的数据');
                    this.buyloglist = res.data.data.list;
                    this.hitoryorderloading = '没有更多了'
                    this.hitoryorderindex ++
                  }else{
                    this.hitoryorderloading = '没有更多了'
                    this.buyloglist = []
                  }
              }else{
                if(res.data.data && res.data.data.list.length>0){
                  this.buyloglist =this.buyloglist.concat(res.data.data.list);
                  this.hitoryorderindex ++
                }else{
                  this.hitoryorderloading = '没有更多了'
                }
              }
            }
          })
          return
        }
        if(this.changeTabsIndex == 3){
          detail= 'recharge'
        }
        if(this.changeTabsIndex == 2){
          detail = 'dcoin';
          this.selectDataTime = moment().format('YYYY-MM')
        }
        walletdetail({
          detail:detail,
          offset:i,
          month:this.selectDataTime?this.selectDataTime:''
        }).then((res) => {
            console.log('收益明细',res.data);
            if(res.data.code == 200){
              if(i==0){
                  if(res.data.data && res.data.data.list.length>0){
                    this.buyloglist = res.data.data.list;
                    this.hitoryorderloading = '没有更多了'
                    this.hitoryorderindex ++
                  }else{
                    this.hitoryorderloading = '没有更多了'
                    this.buyloglist = []
                  }
              }else{
                if(res.data.data && res.data.data.list.length>0){
                  this.buyloglist =this.buyloglist.concat(res.data.data.list);
                  this.hitoryorderindex ++
                }else{
                  this.hitoryorderloading = '没有更多了'
                }
              }
            }
          });
      } else {
        // this.$message.error('请先登录后尝试')
      }
    },
    mobile(e) {
      this.Mobile = e;
    },
    //   提现
    Tixian() {
      this.$router.push("/wodeshouyi");
    },
    pays(e) {
      this.pay = e;
    },
    Chongzhi() {
      this.$refs.nevRef.Pay();
    },
    dianji(e) {
      this.b = e;
    },
    Mingcheng(e,item, i) {
        this.$router.push({
            name: item.path,
            params: {
              id: e,
              tab:i?i:0
            }
        });
    },
  },
  components: {
    Nav,
    Pay,
    slide
  },
};
</script>

<style scoped lang='scss'>
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }
.a {
  background-color: #721edc;
}
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .is-active {
  color: rgba(114, 30, 220, 1);

}
.mask_bg{
  position: fixed;
  z-index: 2;
  background-color: rgba(0, 0, 0, .3);
  top: 0;
  height: 100vh;
  bottom: 0;
  left: 0;
  right: 0;
}
.sael_order{
  position: absolute;
  right: 50%;
  top:50%;
  transform: translate(50%,-50%);
  padding: 34px 22px;
  z-index: 10;
  width: 256px;
  height: 136px;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0px 2px 9px 0px rgba(46,48,52,0.3);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .s_title{
    flex: 2;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .s_btn{
    display: flex;
    width: 100%;
    justify-content: space-around;
    user-select: none;
    span{
      width: 61px;
      cursor: pointer;
      text-align: center;
      line-height: 27px;
      height: 27px;
      font-size: 14px;
      background: #DADADA;
      border-radius: 90px;
    }
  }
}

      .source_button {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;

        .source_cencal {
          flex: 1;
          cursor: pointer;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(0, 0, 0, .1);
        }

        .source_ok {
          flex: 1;
          cursor: pointer;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;

        }
      }
    .push_order_add {
      z-index: 2000;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 464px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.3);
      border-radius: 5px;
      padding: 22px;
      .user_bnt_close{
        margin-top: 36px;
        display: flex;
        justify-content: center;
        div{
          cursor: pointer;
          width: 161px;
          height: 39px;
          background: #721EDC;
          border-radius: 24px;
          text-align: center;
          line-height: 39px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
      .ptitles{
        margin-top: 18px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      .order_status{
        margin-top: 18px;
        display: flex;
        align-items: center;
      justify-content: space-between;
      .checkOrderdefault{
        background: #F4F4F4;
        transition: all .2s;
      }
        .statusImg{
          width: 109px;
          height: 109px;
          border-radius: 9px;
          padding: 14px;
          box-sizing: border-box;

            img{
              width: 80px;
              height: 80px;
            }
        }
      }
      .btnPay{
        margin-top: 50px;
        display: flex;
        justify-content: center;
        span{
          cursor: pointer;
          display: inline-block;
          text-align: center;
          width: 161px;
          height: 40px;
          line-height: 40px;
          background: #721EDC;
          border-radius: 24px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
      .peyorder{
        margin-top: 18px;
        padding: 14px 9px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F4F4F4;
        border-radius: 5px;
        img{
          width: 16px;
          height: 16px;
        }
      }
      .paymoneys{
        margin-top: 18px;
        max-height: 104px;
        background: #F4F4F4;
        border-radius: 5px;
        padding: 0 10px;
        .pname{
          box-sizing: border-box;
           padding: 14px 0;
           font-size: 18px;
           font-family: PingFangSC-Medium, PingFang SC;
           font-weight: 600;
           color: #333333;
           border-bottom: 1px solid rgba(0, 0, 0, .1);
        }
        .pmoney{
         padding: 14px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .user_order_header{
        display: flex;
        align-items: center;
        margin-top: 18px;
        justify-content: space-between;
        .otest{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .orderUsername{
          display: flex;
          align-items: center;
          img{
            margin-right: 8px;
            border-radius: 50%;
            width: 29px;
            height: 29px;
          }
        }
      }
      .order_Id{
        text-align: left;
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .btn_box_order{
        margin-top: 36px;
        display: flex;
        justify-content: space-around;
        .order_btns{
          width: 161px;
          cursor: pointer;
          height: 40px;
          border-radius: 24px;
          border: 1px solid #721EDC;
          text-align: center;
          line-height: 40px;
        }
      }
      .order_timePay{
        margin-top: 18px;
        display: flex;
        justify-content: space-between;

        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;

        .moneys{
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFC000;
        }
      }

      .order_content_detail{
        margin-top: 18px;
        padding: 10px;
        max-height: 230px;
        word-wrap:break-word;
        overflow-y: scroll;
        background: #F4F4F4;
        border-radius: 5px;
        line-height: 24px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;


      }

      .order_box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        margin-top:22px;
        .hong{
          border: 1px solid red;
          color: #ED1010;
        }
        .lan{
          border: 1px solid #1076E9;
          color: #1076E9;
        }
        .tabs {
          width: 36px;
          height: 18px;
          border-radius: 4px;
          text-align: center;
          line-height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          margin-right: 6px;
        }

        .order_title {
          flex: 2;
          text-align: left;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .order_status {
          font-size: 18px;
         margin-top: 0;
          span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }

      }

      .message_order_txt {
        margin-top: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ED1010;
      }

      .btn_sumt {
        margin-top: 50px;
        display: flex;
        justify-content: center;
        .btn_active{
          background: #721EDC !important;
          color: #Fff;
        }
        span {
          cursor: pointer;
          text-align: center;
          width: 161px;
          height: 39px;
          line-height: 39px;
          background: #F2F2F2;
          border-radius: 24px;
        }

      }

      .from_order {
        margin-top: 18px;
        display: flex;
        align-items: center;

        .name_order {
          font-size: 16px;
          width: 50px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-right:34px;
        }

        .items_from_soft {
          width: 50px;
          height: 36px;
          cursor: pointer;
          background: #F4F4F4;
          border-radius: 4px;
          margin-right: 12px;
          line-height: 36px;
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .input_order_text {
          transform: translateY(-5px);
          height: 89px;
          width: 98%;

          textarea {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            padding: 9px 11px;
            border: none;
            outline-style: none;
            background: #F4F4F4;
            border-radius: 4px;
            box-sizing: border-box;
            min-width: 200px;
            width: 100%;
            height: 89px;
          }
        }

        .input_order {
          width: 100%;
          display: flex;
          max-width: 357px;
          height: 36px;
          border-radius: 4px;
          /* padding: 0 12px; */
          box-sizing: border-box;
          align-items: center;

          .order_soft_active {
            background: #721EDC !important;
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF !important;
          }

          .el-radio {
            margin-right: 12px !important;


          }
          .is-checked{
            /deep/ .el-radio__inner {
                   border-color: #721EDC !important;
                       background: #721EDC !important;
                }
                /deep/ .el-radio__label{
                  color:#721EDC !important;
                }
          }


          span {
            font-size: 16px !important;
          }

          .price_order {
            display: flex;
            align-items: center;
            margin-right: 11px;

            input {
              margin-right: 11px;
              width: 73px;
              padding: 0 12px;
              height: 36px;
              line-height: 36px;
              background: #F4F4F4;
              border-radius: 4px;
            }
          }

          input {
            padding: 0 12px;
            color: #999999;
            width: 100%;
            background: #F4F4F4;
            border: none;
            outline-style: none;
            max-width: 357px;
            height: 36px;
          }
        }
      }

      .order_headers {
        height: 22px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        position: relative;
        text-align: center;

        .close_add_order {
          position: absolute;
          height: 22px;
          width: 22px;
          right: 20px;
          top: 0;
        }
      }
    }

.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 1px solid #ebeef5 !important;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #ebeef5;
  width: 100%;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  /* background-color: black; */
  color: #333;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }


  .mydropdown{
    margin-top: 18px;
  }

  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}

.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .hiddenRight{
      /deep/ .el-collapse-item__arrow  {
        display: none !important ;
      }
    }
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      transition: all 1.2s;
      padding: 0 24px;
      .parent_icon {
        display: flex;
        align-items: center;
        margin-right: 4px;
        width: 18px;
        height: 18px;
        img{
          width: 18px;
          height: 18px;
        }
      }
      .actives{
        color: #721edc !important;
        font-size: 15px !important;
      }
      .parent_name {
        display: flex;
        transition: all 0.2s;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
  }
}

.title_box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .lines {
    display: inline-block;
    width: 4px;
    margin-right: 6px;
    border-radius: 4px;
    height: 20px;
    background: #721edc;
  }
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
}

.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  width: 100%;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .user_push_order {
    .header_formtable{
      .headers{
        display: flex;
        justify-content: space-around;
        background-color: #fdf2ff;
        span{
          height: 38px;
          color: #333;
          line-height: 38px;
          flex: 1;
          text-align: center;
        }
      }
    }
    padding: 12px 0;
    box-sizing: border-box;
    .scroll_orders {
      height: calc(100vh - 300px);
      overflow-y: scroll;
      .loadorder{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 46px;
        color: #666;
        background-color:rgba(0, 0, 0, .1);
      }
    }
  }
  .groupOrder{
    /* padding: 18px 0; */
    .content_form{
      display: flex;
      justify-content: space-around;
      background: #F7F8FA;
      height: 38px;
      line-height: 38px;
      span{
        color: #666;
        text-align: center;
        flex: 1;
      }
    }
    .emittxt{
      min-height: 50vh;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .emit{
        width: 164px;
        height: 94px;
        margin-bottom: 18px;
      }
      span{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
    .groupOrder_item{
      margin-bottom: 12px;
      width: 98%;
      /* height: 149px; */
      background: #FFFFFF;
      box-shadow: 0px 0px 9px 0px rgba(114,30,220,0.2);
      border-radius: 5px;
      border: 1px solid #DADADA;

      /* 用户推单 */
      .user_order {
        cursor: pointer;
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        min-height: 158px;
        padding: 22px 12px;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #DADADA;
        position: relative;
        .btn_box_order{
          display: flex;
          justify-content: space-around;
          .order_btns{
            width: 65px;
            height: 25px;
            border-radius: 13px;
            cursor: pointer;
            border: 1px solid #721EDC;
            text-align: center;
            line-height: 25px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #721EDC;
            margin-right: 10px;
          }
        }
        .order_time_pay {
          display: flex;
          margin-top: 10px;
          align-items: center;
          justify-content: space-between;

          .times {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            margin-right: 20px;
          }

          .pay_content {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFC000;
          }
        }

        .order_content {
          margin-top: 22px;
          max-width: 900px;
          width: 100%;
          height: 29px;
          background: #F4F4F4;
          border-radius: 4px;
          border-radius: 4px;
          box-sizing: border-box;
          padding: 0 6px;
          line-height: 29px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .order_title_tab {
          margin-top: 22px;
          padding-bottom: 22px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid rgba(0, 0, 0, .1);
          justify-content: space-between;
          .hong{
            border: 1px solid red;
            color: #ED1010;
          }
          .lan{
            border: 1px solid #1076E9;
            color: #1076E9;
          }
          .tabs {
            width: 36px;
            height: 18px;
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-right: 6px;
          }

          .order_title {
            flex: 2;
            text-align: left;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .order_status {
            font-size: 18px;

            span {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
          }
        }
      }
      }
  }
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
    .itemstabs{
      margin-right: 36px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      cursor: pointer;
    }
    .activestabs{
      color: #111 !important;
      font-weight: 600 !important;
    }
  }
  .alertMsg{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ED1010;
  }
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 24px;
  }
}

.personal-bottom-bottom-right-bottom {
  background-color: #fff;
  box-sizing: border-box;
}

.personal-bottom-bottom-right-bottom-top {
  margin-top: 22px;
  padding-bottom: 26px;
  display: flex;
  border-bottom: 1px solid #dadada;
  .bottom_progress {
    display: flex;
    margin-top: 6px;
    align-items: center;
    .home-top-longin-div-top-center {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .home-top-longin-div-top-center-left {
      display: flex;
      background: #ffffff;
      // box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
      border-radius: 0px 0px 6px 6px;
      border-radius: 2px;
      text-align: center;
      /* border: 1px solid rgba(45, 143, 255, 1); */
      color: rgba(18, 115, 225, 1);
      font-size: 14px;
    }
  }
  .person_top {
    flex: 2;
    .person_grade {
      display: flex;
      align-items: center;
    }
    .person_name {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      .router_edit{
        width: 20px;
        height: 20px;
        margin-left: 4px;
        img{
          width: 20px;
         height: 20px;
        }
      }
    }
    .person_id {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .person_gradebox {
      margin-top: 5px;
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    .person_grade_img {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #721edc;
    }
  }
  .my_person_header {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 12px;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.personal-bottom-bottom-right-bottom-center1 {
  margin-top: 15px;
  border-bottom: 1px #dadada solid;
  .item_pays {
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .titles {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    span {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  .btn_intos {
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    line-height: 28px;
    width: 80px;
    height: 28px;
    background-color: #721edc;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .price_item {
    font-size: 14px;
    color: rgba(213, 213, 213, 1);
  }
  .person_money {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
  }
  .person_money_item {
    margin-bottom: 30px;
    width: 460px;
    height: 60px;
    background: #f7f8fa;
    border-radius: 6px;
    display: flex;
    padding: 0 20px 0 10px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
  }
}
.personal-bottom-bottom-right-bottom-center2 {
  margin-top: 15px;
  width: 100%;
  .userinfo_update {
    display: flex;
    flex-flow: row wrap;
  }
  .number_list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    width: 450px;
    margin-bottom: 30px;
    margin-right: 6%;
  }
  .number_list:nth-child(2n) {
    margin-right: 0 !important;
  }
  .phone_title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .phone_number {
    margin-top: 6px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .phone_img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .update_phone {
    text-decoration: none;
    width: 130px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    background: rgba(114, 30, 220, 1);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    // color: #666666;
    color: #fff;
  }
  .over_updata {
    color: #666666 !important;
    background: #f7f8fa !important;
  }
  .nophone_item {
    font-size: 16px;
  }
  .number_item {
    display: flex;
    align-items: center;
  }
  .items_tight {
    // margin-left: 14px;
    height: 100%;
  }
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.jingyantiao {
  width: 155px;
  margin: 0 4px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/component/yieldmain.vue